module.exports = __webpack_public_path__ + "img/menu-dinein.b4cac560.svg";